// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"O6-z","colorTextValue":"P6-z","swatches":"Q6-z","collapseLink":"R6-z","isCollapsed":"S6-z","dropdown":"T6-z","disabled":"U6-z"};